import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminPayments() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/payments").then((r) => setItems(r.data.items || []));
  }, []);

  const fmt = (cents) => `€ ${((cents || 0) / 100).toLocaleString("nl-BE", { minimumFractionDigits: 2 })}`;

  return (
    <div className="space-y-7">
      <div>
        <h1 className="font-display font-bold text-oc-primary text-[34px]">Betalingen</h1>
        <p className="text-oc-textSecondary mt-1">{items.length} transacties</p>
      </div>

      <div className="bg-white rounded-oc border border-oc-border overflow-hidden">
        <div className="grid grid-cols-12 px-6 py-3 bg-oc-subtle text-[12px] uppercase tracking-[0.05em] font-semibold text-oc-textSecondary">
          <span className="col-span-3">Order ID</span>
          <span className="col-span-2">Bedrag</span>
          <span className="col-span-2">Methode</span>
          <span className="col-span-2">Modus</span>
          <span className="col-span-2">Status</span>
          <span className="col-span-1 text-right">Datum</span>
        </div>
        <div className="divide-y divide-oc-border">
          {items.map((r) => (
            <div key={r.order_id} className="grid grid-cols-12 px-6 py-4 items-center text-[13px]">
              <span className="col-span-3 font-mono text-oc-primary">{r.order_id}</span>
              <span className="col-span-2 font-mono">{fmt(r.amount_cents)}</span>
              <span className="col-span-2 text-oc-textSecondary">{r.payment_method || "—"}</span>
              <span className="col-span-2">
                <span className={`text-[11px] uppercase tracking-wide px-2 py-0.5 rounded-md ${r.mode === "LIVE" ? "oc-status-fair" : "bg-oc-subtle text-oc-textSecondary"}`}>{r.mode || "TEST"}{r.mock ? " · MOCK" : ""}</span>
              </span>
              <span className="col-span-2">
                <span className={`text-[11px] uppercase tracking-wide px-2 py-0.5 rounded-md ${
                  r.status === "completed" ? "oc-status-fair" : r.status === "failed" ? "oc-status-excessive" : "bg-oc-subtle text-oc-textSecondary"
                }`}>{r.status}</span>
              </span>
              <span className="col-span-1 text-right text-oc-textSecondary">{(r.created_at_iso || "").slice(0, 10)}</span>
            </div>
          ))}
          {items.length === 0 && <p className="px-7 py-10 text-center text-oc-textSecondary">Nog geen betalingen</p>}
        </div>
      </div>
    </div>
  );
}
